import { render, staticRenderFns } from "./rejectTicketAffiliate.vue?vue&type=template&id=c4163c00&lang=pug"
import script from "./rejectTicketAffiliate.vue?vue&type=script&lang=js"
export * from "./rejectTicketAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports